export const LAB_TYPE_MAP = [
  {"type": 0, "name": "Normal", },
  {"type":1, "name": "Imitate[BETA]",},
]

export const LAB_TYPE = {
  NORMAL : 0,
  IMITATE : 1,
}